import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return {
    negative: {
      color: '#b00000',
    },
  };
});
